import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { useDispatch } from 'react-redux';
import { createAction } from '@reduxjs/toolkit';
import RoundButton from '@innovyze/stylovyze/lib/components/RoundButton';
/**
 * Closes all snackbar notifications
 */
export const closeAll = createAction('notify/closeAll');
/**
 * Dismisses an individual snackbar's notification by it's key (marks it dismissed to be closed)
 */
export const dismiss = createAction('notify/dismiss');
/**
 * Closes an individual snackbar's notification by it's key
 */
export const close = createAction('notify/close');
/**
 * Default dismiss component. Just an X that dismisses itself.
 */
const Dismiss = ({ notificationKey }) => {
    const dispatch = useDispatch();
    return (React.createElement(RoundButton, { onClick: () => dispatch(dismiss(notificationKey)) },
        React.createElement(CloseIcon, { htmlColor: "white" })));
};
const DEFAULT_NOTIFICATION = {
    onClose: () => { },
    timeout: 3000,
    dismissed: false,
    variant: 'default',
};
const formatNotificationPayload = (text, variant, options) => {
    const key = options.key || (new Date().getTime() + Math.random()).toString();
    const action = options.action || React.createElement(Dismiss, { notificationKey: key });
    return {
        payload: {
            ...options,
            key,
            action,
            text,
            variant,
        },
    };
};
/**
 * Pops up a success notification.
 * @param {string} text The text you want displayed
 * @param {NotificationOptions} options Optional controls for your notification
 */
export const success = createAction('notify/success', (text, options = DEFAULT_NOTIFICATION) => formatNotificationPayload(text, 'success', options));
/**
 * Pops up a warning notification.
 * @param {string} text The text you want displayed
 * @param {NotificationOptions} options Optional controls for your notification
 */
export const warning = createAction('notify/warning', (text, options = DEFAULT_NOTIFICATION) => formatNotificationPayload(text, 'warning', options));
/**
 * Pops up an error notification.
 * @param {string} text The text you want displayed
 * @param {NotificationOptions} options Optional controls for your notification
 */
export const error = createAction('notify/error', (text, options = DEFAULT_NOTIFICATION) => formatNotificationPayload(text, 'error', options));
